







import { Component, Prop, Vue } from "vue-property-decorator";
import { IWallet } from "@/interfaces";
import WalletVoters from "@/components/wallet/Voters.vue";
import { IPFSService } from "@/services";
import { allowedHtmlTags } from "@/constants";
import sanitizeHtml from "sanitize-html";

@Component({
  components: {
    WalletVoters,
  },
})
export default class WalletDelegateDescription extends Vue {
  @Prop({ required: true }) public wallet: IWallet;

  private description = null;

  get delegate() {
    return this.$store.getters["delegates/byPublicKey"](this.wallet.publicKey);
  }

  public mounted() {
    this.fetchDescription();
  }

  private async fetchDescription() {
    // @ts-ignore
    this.description = sanitizeHtml(await IPFSService.fetchData(this.wallet.files.description), allowedHtmlTags);
  }
}
